<div
  [class]="_computedClass()"
  [hlmTooltipTrigger]="disabled() ? 'Veuillez sélectionner une cartographie' : null"
  [hlmTooltipDisabled]="!disabled()"
>
  <div class="py-sm px-md gap-xs flex">
    <span class="text-components-content-primary-main">
      <ng-icon [name]="icone()" hlm size="sm" />
    </span>

    <p class="component-medium-semibold text-content-primary">{{ texte() }}</p>
  </div>

  @if (loadingState()) {
    <div class="mt-sm mr-sm">
      <hlm-spinner
        class="text-components-content-neutral-secondary"
        icon="lucideLoaderCircle"
        hlmTooltipTrigger="Export en cours"
        size="sm"
      />
    </div>
  } @else {
    <button
      class="mt-xxs mr-xxs"
      [disabled]="disabled()"
      [hlmTooltipTrigger]="texte()"
      [hlmTooltipDisabled]="disabled()"
      (click)="action.emit()"
      hlmBtn
      variant="ghost"
      size="xxl"
    >
      <ng-icon name="lucideArrowRight"></ng-icon>
    </button>
  }
</div>
